//Importación de librerias
//---------------SICPO---------------
//Catalogos
import C007PaginasWeb from '../../../src/components/SICPO/Catalogos/C007PaginasWeb.vue';
import C008SeccionesDeLaPaginaWeb from '../../../src/components/SICPO/Catalogos/C008SeccionesDeLaPaginaWeb.vue';
import C004Menus from '../../../src/components/SICPO/Catalogos/C004Menus.vue';
import C001PaginaInicio from '../../../src/components/SICPO/Catalogos/C001PaginaInicio.vue';
import C005TiposPosicion from '../../../src/components/SICPO/Catalogos/C005TiposPosicion.vue';

//---------------Intranet---------------
import C024SeccionesDeIntranet from '../../../src/components/SICPO/Catalogos/C024SeccionesDeIntranet.vue';
import C029PaginasDeIntranet from '../../../src/components/SICPO/Catalogos/C029PaginasDeIntranet.vue';
import C030AreasDeIntranet from '../../../src/components/SICPO/Catalogos/C030AreasDeIntranet.vue';
import C031TiposClinicasIntranet from '../../../src/components/SICPO/Catalogos/C031TiposClinicasIntranet.vue';
import C025ContenidosDeIntranet from '../../../src/components/SICPO/Catalogos/C025ContenidosDeIntranet.vue';

//Creamos y asignamos los datos necesarios de SICPO
const sicpo = [
    { Proviene: 'SICPO', Nombre: 'C007PaginasWeb', datos: C007PaginasWeb },
    { Proviene: 'SICPO', Nombre: 'C008SeccionesDeLaPaginaWeb', datos: C008SeccionesDeLaPaginaWeb },
    { Proviene: 'SICPO', Nombre: 'C004Menus', datos: C004Menus },
    { Proviene: 'SICPO', Nombre: 'C001PaginaInicio', datos: C001PaginaInicio },
    { Proviene: 'SICPO', Nombre: 'C005TiposPosicion', datos: C005TiposPosicion },
    { Proviene: 'SICPO', Nombre: 'C024SeccionesDeIntranet', datos: C024SeccionesDeIntranet },
    { Proviene: 'SICPO', Nombre: 'C029PaginasDeIntranet', datos: C029PaginasDeIntranet },
    { Proviene: 'SICPO', Nombre: 'C030AreasDeIntranet', datos: C030AreasDeIntranet },
    { Proviene: 'SICPO', Nombre: 'C031TiposClinicasIntranet', datos: C031TiposClinicasIntranet },
    { Proviene: 'SICPO', Nombre: 'C025ContenidosDeIntranet', datos: C025ContenidosDeIntranet }
]

export default sicpo;


//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/sicpo.js
// module id = null
// module chunks = 